import React from "react";
import _ from "lodash";
import ReactModal from "react-modal";
import ModalWrapper from "../common/ModalWrapper";
import { decrypt } from "./VaultHelper";
import PasswordEyeInput from "../common/PasswordEyeInput";
import LoadingUI from "components/common/LoadingUI";

const inputClass =
  "bg-white flex w-full border border-gray-400 rounded py-1 px-3 appearance-none leading-normal focus:outline-none focus:border-blue-400 focus:shadow-inner hover:border-gray-500";
const inputClassDisabled =
  "bg-gray-300 flex w-full border border-gray-400 rounded py-1 px-3 appearance-none leading-normal";

ReactModal.setAppElement("body");

class VaultAccountFormModal extends React.Component {
  constructor(props) {
    super(props);

    const { account } = props;
    if (props.modalType === "EDIT") {
      account.password = decrypt(account.secret);
      account.recoveryEmail = decrypt(account.recovery_email);
    }
    const { email = "", password = "", recoveryEmail = "" } = account;

    this.state = {
      email,
      password,
      recoveryEmail,
    };

    this.handleCancel = this.handleCancel.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEmailChanged = this.handleEmailChanged.bind(this);
    this.handlePasswordChanged = this.handlePasswordChanged.bind(this);
    this.handleRecoveryEmailChanged =
      this.handleRecoveryEmailChanged.bind(this);
  }

  handleCancel() {
    this.setState({
      email: "",
      password: "",
      recoveryEmail: "",
    });
    this.props.handleClose();
  }

  handleSubmit() {
    const { email, password, recoveryEmail } = this.state;
    const account = {
      email,
      password,
      recoveryEmail,
    };
    this.props.handleSave(account);
  }

  handleEmailChanged(e) {
    this.setState({ email: e.target.value });
  }

  handlePasswordChanged(e) {
    this.setState({ password: e.target.value });
  }

  handleRecoveryEmailChanged(e) {
    this.setState({ recoveryEmail: e.target.value });
  }

  render() {
    const {
      isOpenModal,
      // handleClose,
      modalType, // ADD, EDIT
      isSaving,
      saveErrorMsg,
      isLoadingModal,
    } = this.props;
    const { email, password, recoveryEmail } = this.state;

    return (
      <ModalWrapper
        isOpen={isOpenModal}
        showCloseFooter={false}
        // handleClose={handleClose}
        width="50%"
        title={
          <div className="border-b -mx-6 mb-4 px-6 pb-2 text-lg font-bold">
            {modalType === "ADD" ? "Add account" : "Edit account"}
          </div>
        }
      >
        <div>
          <div>
            {isLoadingModal ? (
              <LoadingUI></LoadingUI>
            ) : (
              <form
                autoComplete="false"
                onSubmit={(e) => {
                  e.preventDefault();
                  return this.handleSubmit();
                }}
              >
                <div>
                  <div className="my-2">
                    <label
                      className="mb-1 block pr-4 font-semibold leading-none text-gray-800"
                      htmlFor="account-email"
                    >
                      Email
                    </label>
                    <div className="w-2/3">
                      <input
                        className={
                          modalType === "ADD" ? inputClass : inputClassDisabled
                        }
                        id="account-email"
                        type="email"
                        value={email}
                        autoFocus
                        onChange={this.handleEmailChanged}
                        required
                        disabled={modalType !== "ADD"}
                      ></input>
                    </div>

                    {modalType === "ADD" && (
                      <div className="my-2">
                        <label
                          className="mb-1 block pr-4 font-semibold leading-none text-gray-800"
                          htmlFor="i2w-vault-account-password"
                        >
                          Password
                        </label>
                        <div className="w-2/3">
                          {/* <input
                              className={inputClass}
                              id="i2w-vault-account-password"
                              type="text"
                              value={password}
                              onChange={this.handlePasswordChanged}
                              required
                            ></input> */}
                          <PasswordEyeInput
                            id="i2w-vault-account-password"
                            value={password}
                            onChange={this.handlePasswordChanged}
                            required={true}
                          ></PasswordEyeInput>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="my-2">
                  <label
                    className="mb-1 block pr-4 font-semibold leading-none text-gray-800"
                    htmlFor="account-recov-email"
                  >
                    Recovery email
                  </label>
                  <div className="w-2/3">
                    <input
                      className={inputClass}
                      id="account-recov-email"
                      type="email"
                      value={recoveryEmail}
                      onChange={this.handleRecoveryEmailChanged}
                      required
                    ></input>
                  </div>
                </div>

                <div className="mt-8 flex items-center justify-end">
                  <div className="text-red-700">{saveErrorMsg}</div>
                  <button
                    className="rounded flex-shrink-0 border-4 border-transparent px-2 py-1 text-sm text-blue-500 hover:text-blue-800"
                    type="button"
                    onClick={this.handleCancel}
                  >
                    Cancel
                  </button>

                  <button
                    className="rounded flex-shrink-0 border-4 border-blue-500 bg-blue-500 px-2 py-1 text-sm font-semibold text-white hover:border-blue-700 hover:bg-blue-800"
                    type="submit"
                    disabled={isSaving}
                  >
                    {isSaving ? "Saving..." : "Save account"}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </ModalWrapper>
    );
  }
}

export default VaultAccountFormModal;
